export default "__VITE_PUBLIC_ASSET__ea0e80ab__"